import React from 'react';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import StatsSection from './components/StatsSection';
import ServicesSection from './components/ServicesSection';
import WhyChooseUs from './components/WhyChooseUs';
import ContactFooter from './components/ContactFooter';
import './styles/App.css';

function App() {
  return (
    <div className="app-container">
      <HeroSection />
      <AboutSection />
      <StatsSection />
      <ServicesSection />
      <WhyChooseUs />
      <ContactFooter />
    </div>
  );
}

export default App;